import FreelancerAgencyUserTypesEnum from '../../../../Enums/FreelancerAgencyUserTypesEnum';
import FreelancerUserPaymentMethodEnum from '../../../../Enums/FreelancerUserPaymentMethodEnum';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import EditFreelancerUserHelper from '../EditFreelancerUserHelper';

export default class PaymentInformationForChina {
  //#region Validation
  static validityCheckerForChinaPaymentMethod(e, editedItem) {
    return !editedItem.PaymentMethod ||
      (editedItem.UserType === FreelancerAgencyUserTypesEnum.IndependentUser &&
        editedItem.PaymentMethod === FreelancerUserPaymentMethodEnum.BankTransfer) ||
      (editedItem.UserType === FreelancerAgencyUserTypesEnum.Agency &&
        editedItem.PaymentMethod !== FreelancerUserPaymentMethodEnum.BankTransfer)
      ? 'Incorrect Payment Method'
      : '';
  }
  //#endregion

  //#region selectValues
  static getCurrencySelectValues(editedItem) {
    if (
      editedItem.UserType === FreelancerAgencyUserTypesEnum.IndependentUser &&
      editedItem.PaymentMethod === FreelancerUserPaymentMethodEnum.AliPay
    ) {
      return [30];
    } else if (editedItem.UserType === FreelancerAgencyUserTypesEnum.Agency) {
      return [30, 151, 45];
    } else {
      return null;
    }
  }
  //#endregion

  static returnDescriptionTab() {
    return {
      label: 'China Payment Information',
      hide: (item) => EditFreelancerUserHelper.isBillingDetailHidden(item, 6),
      fields: [
        {
          fieldName: 'PaymentCurrencyId',
          label: 'Payment Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
          selectvalues: PaymentInformationForChina.getCurrencySelectValues,
          validityChecker: ValidityHelper.forRequiredSelectField,
          info: (item) =>
            item.PaymentMethod === FreelancerUserPaymentMethodEnum.AliPay
              ? 'In case of AliPay currency have to be CNY.'
              : '',
          onFieldChange: (item) => {
            item.PaymentCurrencyId = EditFreelancerUserHelper.getDefaultPaymentCurrencyValue(item);
          },
        },
        {
          fieldName: 'PaymentMethod',
          label: 'Payment Method',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: EditFreelancerUserHelper.getPaymentMethodSelectOptions,
          validityChecker: PaymentInformationForChina.validityCheckerForChinaPaymentMethod,
          onFieldChange: (item) => {
            item.PaymentCurrencyId = EditFreelancerUserHelper.getDefaultPaymentCurrencyValue(item);
          },
        },
        {
          fieldName: 'PIBankNameAndCode',
          label: 'Bank Name and Code',
          className: 'col-6',
          type: InputTypesEnum.ChinaBankNameCodeLookupSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => item.PaymentMethod !== 'BankTransfer' || parseInt(item.PaymentCurrencyId) !== 30,
        },
        {
          fieldName: 'PIAlipayAccount',
          label: 'Alipay Account',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.AliPay),
        },
        {
          fieldName: 'PIBankName',
          label: 'Bank Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer) ||
            item.PaymentCurrencyId.toString() === '30',
        },
        {
          fieldName: 'PIBranchNameOrId',
          label: 'Branch Name / ID',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer) ||
            item.PaymentCurrencyId.toString() === '30',
        },
        {
          fieldName: 'PISwiftIFSCCode',
          label: 'Swift/IFSC Code',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer) ||
            item.PaymentCurrencyId.toString() === '30',
        },
        {
          fieldName: 'PIAccountHolderName',
          label: 'Account Holder Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, [
              FreelancerUserPaymentMethodEnum.AliPay,
              FreelancerUserPaymentMethodEnum.BankTransfer,
            ]),
        },
        {
          fieldName: 'PIBankAddress',
          label: (item) => (item.PaymentCurrencyId.toString() === '30' ? 'Bank City' : 'Bank Address'),
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIBankAccountNumber',
          label: 'Bank Account Number',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIPaypalWiseWesternUnionEmail',
          label: 'Paypal Email',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forEmailRequired,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.PayPal),
        },
      ],
    };
  }
}
